import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class TahsilatBilgileriGetAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "TahsilatBilgileriGet";
        super(baseUrl);
    }


    getTahsilatBilgileriGet(sicilKodu: number, odemeTarihi: string, vezneKodu: number, seriNo: string, makbuzNo: number) {
        var request = new TahsilatBilgileriGetRequest(sicilKodu, odemeTarihi, vezneKodu, seriNo, makbuzNo);
        return this.post("", request, false);
    }

}
export default new TahsilatBilgileriGetAPI();
class TahsilatBilgileriGetRequest {
    public sicilKodu: number;
    public odemeTarihi: string;
    public vezneKodu: number;
    public seriNo: string;
    public makbuzNo: number;

    constructor(sicilKodu: number, odemeTarihi: string, vezneKodu: number, seriNo: string, makbuzNo: number) {

        this.sicilKodu = sicilKodu;
        this.odemeTarihi = odemeTarihi;
        this.vezneKodu = vezneKodu;
        this.seriNo = seriNo;
        this.makbuzNo = makbuzNo;

    }
}
export { TahsilatBilgileriGetRequest };